import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL!;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY!;

export const supabase = createClient(url, anon, {
  auth: {
    // Convites / magic links funcionam melhor em implicit
    flowType: 'implicit',
    detectSessionInUrl: true,   // processa token vindo na URL
    persistSession: true,
    autoRefreshToken: true,
  },
});